import { ArrowTopRightOnSquareIcon, CloudArrowDownIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import { useEffect } from "react"
import { BarFilters, BarFiltersIcon, BarFiltersLeft, DivProduct, Search } from "../../home-table/styled"
import FilterOrder from "../../components/filters-order";
import { useState } from "react";
import useLanguage from "../../../../../hooks/useLanguage";

const people = [
    { name: 'Lindsay Walton', title: 'Front-end Developer', email: 'lindsay.walton@example.com', role: 'Member' },
    // More people...
]

export default function TableDownload(props) {
    const { t } = useLanguage();

    useEffect(() => {
        console.log("props teste", props)
    }, [props])


    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        // Função que atualiza a largura da janela
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // Adiciona o event listener para redimensionamento da janela
        window.addEventListener('resize', handleResize);

        // Remove o event listener na desmontagem do componente
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        console.log("windowWidth", windowWidth)
    }, [windowWidth])




    return (
        <div style={{ maxWidth: "1440px", margin: "0 auto", backgroundColor: "#fff" }}>
            <div className="px-4 pt-5 sm:px-6 lg:px-8 ">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-base font-semibold leading-6 text-gray-900">{props.config.checkout_message_title}</h1>
                        <p className="mt-2 text-sm text-gray-700">
                            {props.config.checkout_message}
                        </p>
                    </div>
                </div>
                <BarFilters>
                    <span style={{ display: "flex", justifyContent: "space-between" }}>
                        <BarFiltersLeft>
                            <Search>
                                <span>
                                    <MagnifyingGlassIcon style={{ width: "20px" }} />
                                </span>
                                <input onKeyPress={(e) => { e.key == "Enter" && props.setsearch(e.target.value) }} type='text' placeholder={t("page-downloas-pesquisa")} value={props.search} onChange={(e) => { props.setsearch(e.target.value) }} />
                            </Search>
                        </BarFiltersLeft>
                        {/* <BarFiltersIcon>
                            <div style={{ display: "flex" }}>
                                <FilterOrder />
                            </div>
                        </BarFiltersIcon> */}
                    </span>
                </BarFilters>
                <div className="mt-8 flow-root ">
                    <div className="-mx-0 -my-0 overflow-x-auto sm:-mx-0 lg:-mx-0">
                        <div className="inline-block min-w-full py-2 align-middle">
                            <table className="min-w-full divide-y divide-gray-300">
                                <thead>
                                    <tr>
                                        <th
                                            scope="col"
                                            className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-8"
                                        >
                                            {t("page-downloas-produto")}
                                        </th>

                                        {windowWidth >= 1024 &&
                                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                {t("page-downloas-midia")}
                                            </th>}

                                        {windowWidth >= 1024 &&
                                            <th scope="col" className=" px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Tipo
                                            </th>}

                                        <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6 lg:pr-8">
                                            <span className="sr-only">Edit</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 ">
                                    {props.filterProducts.map((item) => (
                                        <tr style={{ cursor: "pointer" }} onClick={() => { props.download(item) }} key={"person.email"}>

                                            <div style={{ minHeight: "80px" }} className="flex items-center gap-x-4 ">
                                                {item.product_image != "" && <img style={{ width: "32px", height: "32px", minWidth: "32px", objectFit: "cover" }} alt="" src={item.product_image} className="rounded" />}
                                                <span style={{ display: "flex", flexDirection: "column" }}>
                                                    <DivProduct style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} className="truncate text-sm font-medium leading-6 text-gray">{item?.product_name}</DivProduct>
                                                    {windowWidth < 1024 && <span style={{ display: "flex" }}>
                                                        {item?.media_name}
                                                        {item.size != null && <div style={{ marginLeft: "8px", minWidth: "max-content", maxHeight: "max-content", ...(props.getColorMediaStyle?.() || {}) }} className={props.getColorMedia()}>
                                                            {props.sizeFiles(item.size)}
                                                        </div>}
                                                    </span>}
                                                    {windowWidth < 1024 && <button
                                                        onClick={() => { props.download(item) }}
                                                        type="button"
                                                        className={props.getColorButton()}
                                                        style={{ width: "max-content", margin: "4px 0px", ...(props.getColorButtonStyle?.() || {}) }}
                                                    >
                                                        {item.type != "url" ?
                                                            < CloudArrowDownIcon aria-hidden="true" className="-ml-0.5 h-5 w-5" /> :
                                                            < ArrowTopRightOnSquareIcon aria-hidden="true" className="-ml-0.5 h-5 w-5" />
                                                        }
                                                        {item.type != "url" ? props.config?.checkout_button : props.config?.checkout_button_link}
                                                    </button>}
                                                </span>

                                            </div>


                                            {windowWidth >= 1024 && <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                <div className="flex gap-x-3">
                                                    <div style={{ width: "content", maxWidth: "500px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} className="font-mono text-sm leading-6 text-gray-700">{item?.media_name}</div>
                                                    {item.size != null && <div className={props.getColorMedia()} style={props.getColorMediaStyle?.()}>
                                                        {props.sizeFiles(item.size)}
                                                    </div>}
                                                </div>
                                            </td>}

                                            {windowWidth >= 1024 && <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                <div className="flex gap-x-3">
                                                    <div className={props.getColorType()} style={props.getColorTypeStyle?.()}>
                                                        {item?.type.toUpperCase()}
                                                    </div>
                                                </div>
                                            </td>}

                                            {windowWidth >= 1024 && <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6 lg:pr-8">
                                                <button
                                                    onClick={() => { props.download(item) }}
                                                    type="button"
                                                    className={props.getColorButton()}
                                                    style={props.getColorButtonStyle?.()}
                                                >
                                                    {item.type != "url" ?
                                                        < CloudArrowDownIcon aria-hidden="true" className="-ml-0.5 h-5 w-5" /> :
                                                        < ArrowTopRightOnSquareIcon aria-hidden="true" className="-ml-0.5 h-5 w-5" />
                                                    }
                                                    {item.type != "url" ? props.config?.checkout_button : props.config?.checkout_button_link}
                                                </button>
                                            </td>}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
